<!--
 * @Author: scg
 * @Date: 2022-01-20 10:40:31
 * @LastEditTime: 2022-01-20 11:12:50
 * @LastEditors: scg
 * @Description:
-->
<template>
  <div class="title-right">
    <div class="google-fanyi">
      <div ref="google_translate_element" id="google_translate_element"></div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  mounted () {
    this.dynamicLoadJs = (jsUrl, fn, jsId = '') => {
      const _doc = document.querySelector('body')
      const script = document.createElement('script')

      script.setAttribute('type', 'text/javascript')
      script.setAttribute('src', jsUrl)
      jsId && script.setAttribute('id', jsId)
      _doc.appendChild(script)
      script.onload = script.onreadystatechange = function () {
        if (
          !this.readyState ||
          this.readyState === 'loaded' ||
          this.readyState === 'complete'
        ) {
          fn && fn()
        }
        script.onload = script.onreadystatechange = null
      }
    }
    let _this = this
    window.googleTranslateElementInit = function () {
      if (_this.$refs.google_translate_element.children.length > 0) {
        return
      }
      // eslint-disable-next-line no-new
      new // eslint-disable-next-line no-undef
      google.translate.TranslateElement(
        {
          // 这个参数不起作用，看文章底部更新，翻译面板的语言
          // pageLanguage: 'zh-CN',
          // 这个是你需要翻译的语言，比如你只需要翻译成越南和英语，这里就只写en,vi
          includedLanguages:
            'en,zh-CN,hr,cs,da,nl,fr,de,el,iw,hu,ga,it,ja,ko,pt,ro,ru,sr,es,th,vi',
          // 选择语言的样式，这个是面板，还有下拉框的样式，具体的记不到了，找不到api~~
          // eslint-disable-next-line no-undef
          layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
          // 自动显示翻译横幅，就是翻译后顶部出现的那个，有点丑，这个属性没有用的话，请看文章底部的其他方法
          autoDisplay: true
          // 还有些其他参数，由于原插件不再维护，找不到详细api了，将就了，实在不行直接上dom操作
        },
        'google_translate_element' // 触发按钮的id
      )
    }
    this.dynamicLoadJs(
      '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit',
      () => {}
    )
  },
  methods: {}
}
</script>

<style scoped>
.title-right {
  /* align-items: center;
        display: flex; */
  min-width: 100px;
  height: 30px;
}
.google-fanyi {
  /* width: 100px; */
  height: 30px;
  min-width: 100px;
}
#google_translate_element {
  /* width: 100px; */
  height: 30px;
  min-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/languageTranslation.vue